import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Fac from 'Icons/Fac';

const useStyles = buildUseStyles('AccountCard', (theme) => ({
  '@keyframes oscillate': {
    '0%': { transform: 'scale(0.5)' },
    '100%': { transform: 'scale(1)' },
  },
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(720deg)' },
  },
  root: {
    animation: '$oscillate 1s infinite alternate', /* Add `alternate` for the oscillation */
    transformOrigin: 'center center',
    animationTimingFunction: 'ease-in-out',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    animation: '$spin 2s infinite', /* Add `alternate` for the oscillation */
    transformOrigin: 'center center',
    animationTimingFunction: 'ease-in-out',
    fill: theme.palette.facet.orange,
    width: '100%',
    height: '100%',
  },
}));

export const LoadingSequence = ({ size }) => {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ height: size, width: size }}>
      <Fac className={classes.image} />
    </div>
  );
};

LoadingSequence.propTypes = {
  size: PropTypes.number.isRequired,
};
